import { Component, OnInit } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';

@Component({
    selector: 'app-redirect',
    template: `
    <p>Redirection en cours...</p>
  `,
})
export class RedirectComponent extends BaseComponent implements OnInit {
    constructor() {
        super();
        window.location.href = 'https://inpost.pl/ayudapudoes-7EJbRvKxZg2TqPmWcXsUzYdN5f9LaMhD';
    }
    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }
}